import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

// Import all page components
import Home from '../pages/Home';
import Solutions from '../pages/Solutions';
import Products from '../pages/Products';
import ProductDetail from '../pages/ProductDetail';
import Blog from '../pages/Blog';
import BlogDetail from '../pages/BlogDetail';
import Contact from '../pages/Contact';
import RequestDemo from '../pages/RequestDemo';
import Privacy from '../pages/Privacy';
import ResourceCenter from '../pages/ResourceCenter';
import ComparePrices from '../pages/ComparePrices';

const DynamicRouter = () => {
  const { pages } = useTheme();

  // Create routes based on available pages for the current domain
  const createRoutes = () => {
    const routes = [];

    // Always include home route
    routes.push(
      <Route key="home" path="/" element={<Home />} />
    );

    // Add routes based on domain configuration
    pages.forEach(page => {
      switch (page) {
        case 'solutions':
          routes.push(
            <Route key="solutions" path="/solutions" element={<Solutions />} />
          );
          break;
        case 'products':
          routes.push(
            <Route key="products" path="/products" element={<Products />} />
          );
          routes.push(
            <Route key="product-detail" path="/products/:id" element={<ProductDetail />} />
          );
          break;
        case 'blog':
          routes.push(
            <Route key="blog" path="/blog" element={<Blog />} />
          );
          routes.push(
            <Route key="blog-detail" path="/blog/:slug" element={<BlogDetail />} />
          );
          break;
        case 'contact':
          routes.push(
            <Route key="contact" path="/contact" element={<Contact />} />
          );
          break;
        case 'resources':
          routes.push(
            <Route key="resources" path="/resources" element={<ResourceCenter />} />
          );
          break;
        case 'compare-prices':
          routes.push(
            <Route key="compare-prices" path="/compare-prices" element={<ComparePrices />} />
          );
          break;
        default:
          break;
      }
    });

    // Always include request demo route
    routes.push(
      <Route key="request-demo" path="/request-demo" element={<RequestDemo />} />
    );


    // Always include privacy policy route
    routes.push(
      <Route key="privacy" path="/privacy" element={<Privacy />} />
    );


    // Add catch-all route for 404
    routes.push(
      <Route key="404" path="*" element={<Navigate to="/" replace />} />
    );

    return routes;
  };

  return (
    <Routes>
      {createRoutes()}
    </Routes>
  );
};

export default DynamicRouter;
